import { Label } from '@/components/ui/label';
import { useAuth } from '@/context/AuthContext';
import EditProfile from './EditProfile';

export default function DoctorProfile() {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-heading font-bold text-background-dark">Profile Information</h2>
        <EditProfile />
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-8">
        {user?.doctor_photo && (
          <div className="flex justify-center mb-6">
            <img
              src={user.doctor_photo}
              alt="Doctor photo"
              className="h-40 w-40 rounded-full object-cover border-4 border-primary/20"
            />
          </div>
        )}

        <div className="space-y-6">
          <div>
            <Label>Full Name</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.full_name}</p>
          </div>

          <div>
            <Label>Email</Label>
            <p className="mt-2 text-slate-900">{user?.email}</p>
          </div>

          <div>
            <Label>Phone</Label>
            <p className="mt-2 text-slate-900">{user?.phone}</p>
          </div>

          <div>
            <Label>Specialization</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.specialization}</p>
          </div>

          <div>
            <Label>Clinic Name</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.clinic_name}</p>
          </div>

          <div>
            <Label>Clinic Address</Label>
            <p className="mt-2 text-slate-900">{user?.clinic_address}</p>
          </div>

          <div>
            <Label>City</Label>
            <p className="mt-2 text-slate-900">{user?.city}</p>
          </div>

          {user?.visiting_card && (
            <div>
              <Label>Visiting Card</Label>
              <div className="mt-2">
                <img
                  src={user.visiting_card}
                  alt="Visiting card"
                  className="max-w-md rounded-lg border border-slate-200"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}